import React from "react";
import { Grid } from "@mui/material";
import FileUpload from "../../utils/FileUpload";
import UserImage from "../../assets/img/UserImage.png";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  DownloadUsersTemplateService,
  uploadBulkUsersService,
  DownloadErrorLogsService,
} from "../../services/BulkUploadServices";
import download from "downloadjs";
import useGlobalState from "../../../src/Context";

const BulkUsersUpload = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }, dispatch] = useGlobalState();
  const loggedInUserId = auth.ldapParam.userId;
  const downloadErrorLogs = async () => {
    try {
      setLoading(true);
      const param = {
        requestType: 0,
        id: loggedInUserId,
      };
      const response = await DownloadErrorLogsService(param);
      const content = response.headers["content-type"];
      download(response.data, "UserErrorLogs.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const downloadTemplate = async () => {
    try {
      setLoading(true);
      const response = await DownloadUsersTemplateService();
      const content = response.headers["content-type"];
      download(response.data, "UsersTemplate.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const onFileChange = (event) => {
    if (
      event.target.files[0]?.type === "text/csv" ||
      event.target.files[0]?.type === "application/vnd.ms-excel" ||
      event.target.files[0]?.type === "application/vnd.msexcel" ||
      event.target.files[0]?.type === "application/csv" ||
      event.target.files[0]?.type === "text/comma-separated-values"
    ) {
      if (event.target.files[0].size >= 10485760) {
        showNotification(
          "Error",
          "File too Big, please select a file less than 10mb"
        );
      } else {
        uploadFile(event.target.files[0]);
      }
    } else {
      showNotification("Error", "Invalid type selected, Please try again.");
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    var createdBy = JSON.stringify(loggedInUserId);
    formData.append("file", file);
    formData.append("createdBy", createdBy);
    try {
      setLoading(true);
      const uploadResponse = await uploadBulkUsersService(formData);
      if (uploadResponse.messageCode === 200) {
        const response = uploadResponse.bulkParam;
        showNotification(
          "Upload Successful",
          `${response?.fileName} File Uploaded `,
          "success"
        );

      } else {

        showNotification("Error", uploadResponse.message);
      }
    } catch (err) {
      showNotification("Error", "Failed To submit File");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={0} sx={{ mt: 0, pb: 1 ,alignItems:"center"}}>
        <Grid item xs={3} sx={{ mt: "0" }}>
          <img src={UserImage} alt="User" width={60} />
        </Grid>
        <Grid item xs={4} sx={{ color: "#757575", fontSize: "16px", fontWeight: "500", mt: "0" }}>
          <p>Bulk Users </p>
        </Grid>

        <Grid item xs={5} sx={{ mt: "0" ,textAlign:"left"}} >
          <FileUpload
            onFileChange={onFileChange}
            userButton={true}
            showDownload={true}
            download={downloadTemplate}
            downloadErrors={downloadErrorLogs}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BulkUsersUpload;
